import React, { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { TileListComponent } from '@/components';
import { cn } from '@/utils';
import Modal from './Modal';

const DataCheck = ({
                 parentId,
                 headline,
                 onItemClick,
                 loadingIndex,
                 isFetching,
                 values,
                 tooltip
               }) => {
  const [componentState, updateComponentState] = useImmer({
    isModalOpen: false,
  });

  const openModal = () => {
    updateComponentState((draft) => {
      draft.isModalOpen = true;
    });
  };

  const closeModal = () => {
    updateComponentState((draft) => {
      draft.isModalOpen = false;
    });
  };

  useEffect(() => {
    document.body.style.overflow = componentState.isModalOpen ? 'hidden' : '';
  }, [componentState.isModalOpen]);

  useEffect(() => {
    if (!loadingIndex && componentState.isModalOpen) {
      closeModal();
    }
  }, [loadingIndex]);

  return (
    <>
      <TileListComponent
        id='data-check'
        parentId={parentId}
        getItemDataAttributes={(item) => ({'data-check': item.id})}
        tileClassName={cn('w-1/' + Math.min(values.length, 3), "h-6xl tablet:h-[4.375rem]")}
        isDisabled={isFetching}
        items={values}
        LoadingIcon={() => (
          <ft-spinner size="small"></ft-spinner>
        )}
        linkText={Drupal.t('More Information')}
        onLinkClick={() => openModal()}
        {...{
          headline,
          onItemClick,
          loadingIndex
        }}
      />
      <If condition={componentState.isModalOpen}>
        <Modal
          closeModal={() => closeModal()}
          {...{
            parentId,
            onItemClick,
            values,
            tooltip
          }}
        />
      </If>
    </>
  );
};

export default DataCheck;
